// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryNoFurtherUpdateInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryNoFurtherUpdateInterop.ts';

import { WebPanelLocationQuery, useWebPanelLocationBatchResult } from './WebPanelLocation.tsx';
import type {
	WebPanelLocationQuery$data,
	WebPanelLocationQuery$variables,
} from './__generated__/WebPanelLocationQuery.graphql.ts';

export const useConnectAppsData = ({
	contentId,
	location,
}: {
	contentId: string;
	location: string;
}): string => {
	const batchResult = useWebPanelLocationBatchResult(location);
	const baseOptions = {
		variables: {
			contentId,
			location,
		},
		skip: Boolean(batchResult),
	};

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = useQueryNoFurtherUpdateInterop<
		WebPanelLocationQuery$data,
		WebPanelLocationQuery$variables
	>(WebPanelLocationQuery, baseOptions);
	const panels = batchResult?.data?.webPanels || data?.webPanels || [];
	return panels.map((panel) => panel?.moduleKey).join(',');
};
